import React from 'react';
import FreightCostTable from './FreightCostTable';

const HydrocarbonCondensatTable = ({ refreshTrigger }) => (
  <FreightCostTable procurementTypeHeader='2' refreshTrigger={refreshTrigger} />
);

export default React.memo(HydrocarbonCondensatTable);
